module.exports = __webpack_public_path__ + "img/subs.9be36e00.png";